import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-button-cell-renderer',
  templateUrl: './button-cell-renderer.component.html',
  styleUrls: ['./button-cell-renderer.component.scss']
})
export class ButtonCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  showButtons = true;
  buttonConfig: { [key: string]: boolean } = {};

  agInit(params: any): void {
    this.params = params;
    this.updateButtonConfig();

    const manualExists = 'manual' in params?.data;
    this.showButtons = !manualExists || params?.data?.manual === true;
  }

  refresh(params: any): boolean {
    this.params = params;
    this.updateButtonConfig();
    return true;
  }

  private updateButtonConfig(): void {
    if (typeof this.params.buttonConfig === 'function') {
      this.buttonConfig = this.params.buttonConfig(this.params.data);
    } else {
      this.buttonConfig = this.params.buttonConfig || {};
    }
  }

  onButtonClick(action: 'update' | 'delete' | 'import' | 'configure' | 'showAssets' | 'submit' | 'view' | 'map' | 'startProgram') {
    const rowIndex = this.params.node.rowIndex;
    const rowData = this.params.data;
    this.params.onActionClicked(action, rowIndex, rowData);
  }
}